// A list asked for with an explicit page size (for example `?page_size=1000`) is read to the end, so a
// company with more rows than one page still gets every row. A list asked for without one is left as the
// server pages it. `get` is the client's GET; the other pages are requested by number.
const MAX_PAGES = 50;

export async function fetchAllPages(get, path) {
  const first = await get(path);
  if (!/[?&]page_size=\d+/.test(path) || !first || !first.next || !Array.isArray(first.results)) return first;
  const joiner = path.includes("?") ? "&" : "?";
  const results = [...first.results];
  let last = first;
  for (let page = 2; last.next && page <= MAX_PAGES; page += 1) {
    last = await get(`${path}${joiner}page=${page}`);
    if (!last || !Array.isArray(last.results)) break;
    results.push(...last.results);
  }
  return { ...first, results, next: null };
}
